import * as Sentry from '@sentry/react'

import React from 'react'
import ReactDOM from 'react-dom'

import './i18n'

import App from './App'
import config from './config'

import { Provider } from 'react-redux'
import { configureStore } from './redux/store'

const parseSampleRate = (value, fallback) => {
  const parsed = Number.parseFloat(value)

  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) {
    return fallback
  }

  return parsed
}

const isProduction = process.env.NODE_ENV === 'production'
const sentryEnabled = isProduction && Boolean(config.SENTRY_DSN)
const replaySessionSampleRate = parseSampleRate(
  config.SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  isProduction ? 0.1 : 1.0
)
const replayOnErrorSampleRate = parseSampleRate(config.SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE, 1.0)

if (!isProduction) {
  // eslint-disable-next-line no-console
  console.warn('[Sentry Frontend] Disabled outside production environment')
} else if (!config.SENTRY_DSN) {
  // eslint-disable-next-line no-console
  console.warn('[Sentry Frontend] Disabled: REACT_APP_SENTRY_DSN is not configured')
}

Sentry.init({
  dsn: config.SENTRY_DSN,
  enabled: sentryEnabled,
  environment: process.env.NODE_ENV || 'development',
  sendDefaultPii: false,
  integrations: sentryEnabled
    ? [
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true
        })
      ]
    : [],
  replaysSessionSampleRate: replaySessionSampleRate,
  replaysOnErrorSampleRate: replayOnErrorSampleRate
})

ReactDOM.render(
  <Provider store={configureStore({})}>
    <App />
  </Provider>,
  document.getElementById('root')
)
